export default __webpack_public_path__ + "static/media/newLead05.233162a8.png";